import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IComponentOptions, IController, IModule, IOnChangesObject, IScope} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {BrukerRessurs} from "felles/tjenester/ressurser/BrukerRessurs";
import {gettextCatalog} from "angular-gettext";
import {Debugger} from "debug";
import {BekreftMobilnummerDialog} from "../../modale/bekreftMobilnummer/bekreftMobilnummerDialog";
import _ from "lodash";
import {ReautentiseringDialogKontroller} from "../../modale/reautentisering/reautentisering";

const debug: Debugger = require('debug')('BrukerKontroller');
const css = require('./bruker.scss');


export function registrerBrukerKomponent(angular: IModule) {
    angular
      .component('wmBrukerBruker', brukerKomponentDef());
}

export function brukerKomponentDef(): IComponentOptions {
    return {
        bindings: {
            bruker: "<"
        },
        controller: BrukerKontroller.forInjisering(),
        template: require('./bruker.html')
    };
}


export class BrukerKontroller implements IController {

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.md.$mdDialog,
            BrukerRessurs.regNavn,
            Kontekst.regNavn,
            regNavn.gettext.gettextCatalog,
            BrukerKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $mdDialog: angular.material.IDialogService,
                private brukerRes: BrukerRessurs,
                private kontekst: Kontekst,
                private gettextCatalog: gettextCatalog) {
    }

    bruker: l.BrukerModell; //settes via bindings/$onChanges

    iRedigeringsmodus = false;
    iRedigeringSensitivemodus = false;
    erMobilnummerPaakrevet = false;
    lagrer = false;
    redigerSensitiveBrukerspesifikasjon: l.OppdaterBrukerSensitivSpesifikasjon;
    // brukernavn vises kun hvis e-post og brukernavn ikke er likt
    visBrukernavn = false;

    visKontaktInfo() {
        return !this.iRedigeringsmodus && !this.iRedigeringSensitivemodus;
    }

    rediger() {
        this.iRedigeringsmodus = true;
    }

    redigerSensitiveData() {
        this.erMobilnummerPaakrevet = _.includes(this.kontekst.autentisertBruker().autentiseringsmetoder, l.Autentiseringsmetode.smsOtp);
        this.redigerSensitiveBrukerspesifikasjon = {
            id: this.bruker.id,
            mobilnummer: this.bruker.mobilnummer,
            epost: this.bruker.epost,
            // dersom e-post og brukernavn er likt, så vil kun e-post eksponeres. Vi vil fortsette å holde de i synk.
            brukernavn: this.bruker.brukernavn,
            autentiseringsinfo: null
        };
        this.iRedigeringSensitivemodus = true;
    }

    lagreSensitiveData() {
        this.lagrer = true;
        ReautentiseringDialogKontroller.visReautentiseringDialog(
          this.gettextCatalog.getString('Bekreft identiteten din for å lagre e-post/mobil'),
          autentiseringsinfo => this.validerAutentiseringsinfoOgOppdater(autentiseringsinfo),
          this.$mdDialog)
          .finally(() => this.lagrer = false);
    }

    private validerAutentiseringsinfoOgOppdater(autentiseringsinfo: l.Reautentiseringsinformasjon) {
        this.redigerSensitiveBrukerspesifikasjon.autentiseringsinfo = autentiseringsinfo;
        if (_.isEmpty(this.redigerSensitiveBrukerspesifikasjon.mobilnummer)) this.redigerSensitiveBrukerspesifikasjon.mobilnummer = null;
        return this.brukerRes.oppdaterSensitiveData(this.redigerSensitiveBrukerspesifikasjon).$promise
          .then((oppdateringsResultat: l.OppdatertSensitiveDataModell) => {
              if (oppdateringsResultat.autentiseringOk) {
                  this.kontekst.relastBruker();
                  this.bruker = oppdateringsResultat.brukerModell;
                  this.iRedigeringSensitivemodus = false;
                  if (oppdateringsResultat.mobilnummerKreverValidering) this.visDialogForValideringAvMobilnummer();
              }
              return oppdateringsResultat.autentiseringOk;
          });
    }

    brukerLagret() {
        this.iRedigeringsmodus = false;
        this.$scope.$applyAsync(); //siden vi blir kalt fra ng2
    }

    avbrytRediger() {
        this.iRedigeringsmodus = false;
        this.iRedigeringSensitivemodus = false;
        this.$scope.$applyAsync(); //siden vi blir kalt fra ng2 (bare $apply her førte til feilen: $apply already in progress
    }

    $onChanges(changes: IOnChangesObject) {
        if (changes['bruker']) {
            this.bruker = changes['bruker'].currentValue;
            this.visBrukernavn = this.bruker.brukernavn !== this.bruker.epost
        }
    }

    //hjelpemetoder

    private visDialogForValideringAvMobilnummer() {
        BekreftMobilnummerDialog.visBekreftMobilnummerDialog(this.$mdDialog);
    }
}
